import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
    IconButton
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { ColorButton } from "../utils/ColorButton";
import { grey } from '@material-ui/core/colors';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(3),
        minWidth: '350px',
        padding: theme.spacing(2)
    },
    formControl: {
        minWidth: '100%',
        margin: theme.spacing(2, 2, 2),
    },
    actionButtons: {
        margin: theme.spacing(2, 2, 2)
    },
    cancel: {
        color: 'white',
        backgroundColor: grey[400],
        '&:hover': {
            backgroundColor: grey[600],
        },
    },
    error: {
        color: 'red',
        marginTop: theme.spacing(1)
    },
    success: {
        color: 'green',
        marginTop: theme.spacing(1)
    }
}));

export default function ChangePasswordModal({ open, onClose, user }) {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [shouldClose, setShouldClose] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async () => {
        setError('');
        setSuccessMessage('');
        setErrors({});

        if (!newPassword) {
            setError('Por favor, ingrese una nueva contraseña');
            return;
        }

        setLoading(true);

        try {
            const api = axios.create({
                baseURL: process.env.REACT_APP_BASE_URL,
                headers: {
                    "Content-Type": "application/json"
                }
            });

            const userId = user.id; // Assuming user object has an id
            const newData = user;
            newData['password'] = newPassword;
            console.log({ newData });
            const response = await api.put(`/users/${userId}`, newData);
            if (response.status === 200){
            setSuccessMessage('Contraseña cambiada correctamente');
            setTimeout(() => {
                setNewPassword('');
                setSuccessMessage('');
                setShouldClose(true);
            }, 1000);}
            else{
                setError('Error al cambiar la contraseña. Intente nuevamente.');
            }

        } catch (error) {console.error("Error en el registro:", error);

            if (error.response) {
                var details = error.response.data?.details;
                if (details) {
                    setErrors(details);
                }
                else {
                    setError(`Error ${error.response.status}: ${error.response.data?.message || "Ocurrió un error inesperado."}`);
                }
            } else if (error.request) {
                console.error("No se recibió respuesta del servidor:", error.request);
                setError("No se recibió respuesta del servidor. Verifica tu conexión.");
            } else {
                console.error("Error en la configuración de la solicitud:", error.message);
                setError("Error al cambiar la contraseña. Intente nuevamente.");
            }
        }

        setLoading(false);
    };

    if (shouldClose) {
        onClose();
        setShouldClose(false);
    }

    return (
        <Dialog
            open={open && !shouldClose}
            onClose={onClose}
            PaperProps={{
                style: {
                    minWidth: '400px',
                    minHeight: '300px',
                    maxWidth: '500px'
                },
            }}
        >
            <DialogTitle className={classes.dialogTitle}>Cambiar Contraseña</DialogTitle>
            <DialogContent>
                <TextField
                    variant="outlined"
                    fullWidth
                    label="Usuario"
                    value={(user ? `${user.name} ${user.lastName} - ${user.documentNumber}` : '')}
                    autoFocus
                    disabled
                    InputProps={{ style: { fontWeight: 'bold' } }}
                    style={{ marginBottom: '16px' }}
                />
                <TextField
                    variant="outlined"
                    required
                    fullWidth
                    label="Nueva Contraseña"
                    type={showPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    error={errors.password}
                    helperText={errors.password && (
                        <Typography variant="body2" className={classes.error}>
                            {errors.password.map((error, index) => (
                                <div key={index}>- {error}</div>
                            ))}
                        </Typography>
                    )}
                    InputProps={{
                        endAdornment: (
                            <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                            >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        ),
                    }}
                />
                {error && <Typography ariant="body2" className={classes.error}>{error}</Typography>}
                {successMessage && <Typography className={classes.success}>{successMessage}</Typography>}
            </DialogContent>
            <DialogActions className={classes.actionButtons}>
                <ColorButton onClick={onClose}
                    color="secondary"
                    variant="contained"
                    disabled={loading}
                    className={classes.cancel}
                >
                    Cancelar
                </ColorButton>
                <ColorButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    className={classes.submit}
                    disabled={loading}
                >
                    {loading ? 'Cargando...' : 'Cambiar'}
                </ColorButton></DialogActions>
        </Dialog>
    );
}